module.exports = __webpack_public_path__ + "img/bg_hezuo1.a5244d40.png";